import { useMemo } from 'react';

import filter from 'lodash/filter';

import { usePayPeriodGroupsGet } from '@sbv-clients/data-access-api';

import {
  BaseFieldProps,
  createOptionsFieldBuilder,
} from '../hoc/fields-builder';

type ExtraParameters = unknown;

const useOptions = (body: ExtraParameters) => {
  const { data } = usePayPeriodGroupsGet();
  const options = useMemo(
    () =>
      filter(data, (item) => Boolean(item.payPeriodGroupID)).map((item) => ({
        id: item.pkPayPeriodGroupID!,
        label: item.payPeriodGroupID ?? '',
        value: item.pkPayPeriodGroupID as number,
      })),
    [data]
  );
  return { options };
};

type Props = BaseFieldProps & ExtraParameters;

const hookParamsGetter = (props: Props): ExtraParameters => ({});

export const { PayPeriodGroupFormSelectField } = createOptionsFieldBuilder({
  prefix: 'PayPeriodGroup',
  useOptionsHook: useOptions,
  extractHookParams: hookParamsGetter,
});
